import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { doc7Context } from "../../pages/doc7/doc7";
import curriculumService from "../../services/curriculum.service";
import doc7Service from "../../services/doc7.service";
import SendDoc7 from "./sendDoc7";

const FindDoc7 = () => {
  const { setDoc7List } = useContext(doc7Context);
  const me = useSelector((state: any) => state.me);
  const [curriSelect, setCurriSelect] = useState([]);
  const [level, setLevel] = useState("");
  const [curriCode, setCurriCode] = useState("");
  const [year, setYear] = useState("");
  const [selectCurriCode, setSelectCurriCode] = useState("");

  useEffect(() => {
    (async () => {
      await curriculumService.findCurri({ level, curriCode }).then((res) => {
        // console.log(res.data);
        setCurriSelect(res.data.filter((x: any) => x.type === "tqf"));
        if (res.data.length == 0) {
          setSelectCurriCode("");
        }
      });
    })();
  }, [level, curriCode]);

  const levelOnChange = (e: any) => {
    setLevel(e.target.value);
    setSelectCurriCode("");
  };

  const curriCodeOnChange = (e: any) => {
    setCurriCode(e.target.value);
  };

  const handleSubmit = async () => {
    // console.log(level);

    await await doc7Service
      .findDoc7({
        year,
        level,
        curriCode,
        selectCurriCode,
      })
      .then((res) => {
        setDoc7List(res.data);
      });

    // สำหรับส่งไปค้นหา
    // year: number;
    // level: string;
    // curriCode: string;
    // selectCurriCode: string;
  };

  return (
    <>
      <div className="p-3 mb-4 bg-light rounded-4">
        <div className="row">
          <div className="col-2">
            <input
              type="text"
              className="form-control"
              name="year"
              placeholder="ปีการศึกษา"
              value={year}
              onChange={(e) => {
                setYear(e.target.value);
              }}
            ></input>
          </div>
          <div className="col-2">
            <select
              className="form-select"
              name="level"
              value={level}
              onChange={levelOnChange}
            >
              <option value="">ระดับการศึกษา</option>

              <option value="ป.ตรี">ป.ตรี</option>
              <option value="ป.โท">ป.โท</option>
            </select>
          </div>
          <div className="col">
            <input
              type="text"
              className="form-control"
              name="curriCode"
              placeholder="รหัสหลักสูตร"
              value={curriCode}
              onChange={curriCodeOnChange}
            ></input>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-10">
            <select
              className="form-select"
              name="curri"
              value={selectCurriCode}
              onChange={(e) => {
                setSelectCurriCode(e.target.value);
              }}
            >
              <option value="">เลือกหลักสูตร</option>
              {curriSelect.map((curriItem: any) => {
                return (
                  <option value={curriItem.id} key={curriItem.id}>
                    (รหัสหลักสูตร {curriItem.curriCode}) - {curriItem.name}
                  </option>
                );
              })}
            </select>
          </div>
          {me.role === "Admin" && (
            <div className="col-2">
              <button className="btn btn-success" onClick={handleSubmit}>
                ค้นหา
              </button>
              <SendDoc7 />
            </div>
          )}

          {me.role === "Member" && (
            <div className="col-2">
              <button className="btn btn-success col-12" onClick={handleSubmit}>
                ค้นหา
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FindDoc7;
